"use strict";import{css as s}from"@spectrum-web-components/base";const e=s`
    slot[name=longpress-describedby-descriptor]{display:none}
`;export default e;
//# sourceMappingURL=overlay-trigger.css.js.map
